import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImageHelper"; 
import Modal from "react-modal";

const ImageCropperModalMulti = ({ images = [], onComplete, onClose, acceptRatio }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImages, setCroppedImages] = useState([]);

  const currentImage = images[currentIndex];

  const onCropCompleteHandler = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCrop = async () => {
    const croppedImage = await getCroppedImg(currentImage, croppedAreaPixels);
    setCroppedImages(prev => [...prev, croppedImage]);

    if (currentIndex < images.length - 1) {
      setCurrentIndex(currentIndex + 1);
      resetCrop();
    } else {
      onComplete(croppedImages.concat(croppedImage)); 
      onClose();
    }
  };

  const resetCrop = () => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
  };

  const handleCancel = () => {
    onClose(); 
  };

  return (
    <Modal isOpen onRequestClose={onClose}>
      <div className="crop-container" style={{ position: "relative", height: 359, width: "100%" }}>
        <Cropper
          image={currentImage}
          crop={crop}
          zoom={zoom}
          aspect={acceptRatio}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropCompleteHandler}
        />
      </div>
      <div className="text-right mt-3">
        <p>Image {currentIndex + 1} of {images.length}</p>
        <button type="button" className="backbutton" onClick={handleCancel}>
          Cancel
        </button>
        <button type="button" className="savebtn-click" onClick={handleCrop}>
          {currentIndex < images.length - 1 ? "Next" : "Finish"}
        </button>
      </div>
    </Modal>
  );
};

export default ImageCropperModalMulti;